/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import { ReactComponent as LockedIcon } from "../assets/rls-status-icons/patient-locked.svg";
import { ReactComponent as UnlockedIcon } from "../assets/rls-status-icons/patient-warn.svg";
import { ReactComponent as SyncingIcon } from "../assets/rls-status-icons/patient-syncing.svg";

export const PatientSyncStatus = {
  NOTREADY: "NOTREADY",
  LOCKED: "LOCKED",
  UNLOCKED: "UNLOCKED",
  SYNCING: "SYNCING",
  WARNING: "WARNING",
};

export const PatientSyncStatusMsgs = [
  {
    key: PatientSyncStatus.SYNCING,
    text: "Syncing Patient Profile",
    Icon: SyncingIcon,
  },
  {
    key: PatientSyncStatus.NOTREADY,
    text: "Patient sync is temporarily unavailable, please check that the patient demographics are properly set up and try again.",
    Icon: UnlockedIcon,
  },
  {
    key: PatientSyncStatus.WARNING,
    text: "Patient sync is temporarily unavailable and will be attempted when availability is reestablished",
    Icon: UnlockedIcon,
  },
  {
    key: PatientSyncStatus.LOCKED,
    text: "Patient Profile synced with EHR. Last Update at {}",
    Icon: LockedIcon,
  },
  {
    key: PatientSyncStatus.UNLOCKED,
    text: "Patient Profile not synced with EHR. Last Update at {}",
    Icon: UnlockedIcon,
  },
];
